import { createAction } from 'redux-actions';

export const clearReservationAvailableEvents = createAction(
  'CLEAR_RESERVATION_AVAILABLE_EVENTS'
);
